import { FormGroup, Validators } from '@angular/forms';
import { maxLenghtValidator } from '@shared/validators/max-length.validator';
import { SectoresService } from 'src/app/core/providers/services/sectores/sectores.service';
import { Numbers } from 'src/app/utils/constants';
import LegalStepTwoComponentUtilsExtended from './legal-step-two.components.utils-extended';

export default class LegalStepTwoComponentUtils {

  /**
   * constructor
   * @param sectorsSrv sectorsSrv
   */
  constructor(private readonly sectorsSrv: SectoresService) {
    this.sectorsSrv = sectorsSrv;
    this.utilsExtended2 = new LegalStepTwoComponentUtilsExtended();
  }

  public disabledSec = false;
  public disabledRazSo = false;
  public disabledEmail = false;
  public disabledPhone = false;
  public disabledDir = false;
  public disabledCP = false;
  public disabledMuni = false;
  public disabledProv = false;
  public showModal2 = false;
  public displayModal2: boolean;
  public sectorchange: { name: string, value: any };
  public typeOwner: 'Particular' | 'Empresa';
  public formDataUtils: FormGroup;
  public formConfigUtils: any;
  public component: any;
  public utilsExtended2: any;

  /**
   * datalayer
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer(formData: any, gtmService: any): void {
    const FORM_NAME: any = formData.get('insureSelected').value;
    const DATA_LAYER_D: any = {
      event: 'ev_contratacion',
      event_category: 'contratacion',
      event_action: FORM_NAME.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'jurídico',
      paso: 'c2'
    };
    gtmService.pushTag(DATA_LAYER_D);
  }

  /**
   * datalayer2
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer2(formData: any, gtmService: any): void {
    const FORM_NAME: any = formData.get('insureSelected').value;
    const DATA_LAYER_D: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: FORM_NAME.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'jurídico',
      paso: 't2'
    };
    gtmService.pushTag(DATA_LAYER_D);
  }

  /**
   * setValidator
   * @param formData formData
   * @param formConfig formConfig
   * @param patternEmail patternEmail
   * @param patternMobile patternMobile
   * @param patternCP patternCP
   */
  public setValidator(formData: any, formConfig: any, patternEmail: any, patternMobile: any, patternCP: any): void {
    this.formDataUtils = formData;
    this.formDataUtils.get(formConfig.documentType.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).setValidators([
      maxLenghtValidator(Numbers.number15), Validators.required]);
    this.formDataUtils.get(formConfig.name.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(formConfig.email.linkFormPath).setValidators([
      Validators.pattern(patternEmail), Validators.required]);
    this.formDataUtils.get(formConfig.telephone.linkFormPath).setValidators([
      Validators.pattern(patternMobile), Validators.required]);
    this.formDataUtils.get(formConfig.direction.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).setValidators([
      Validators.pattern(patternCP), Validators.required]);
    this.formDataUtils.get(formConfig.municipality.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(formConfig.province.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(formConfig.country.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(formConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.email.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.telephone.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.municipality.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.province.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.country.linkFormPath).updateValueAndValidity();
  }

  /**
   * removeValidator
   * @param formData formData
   * @param formConfig formConfig
   */
  public removeValidator(formData: any, formConfig: any): void {
    this.formDataUtils = formData;
    this.formDataUtils.get(formConfig.documentType.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.name.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.email.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.telephone.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.direction.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.municipality.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.province.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.country.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.email.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.telephone.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.municipality.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.province.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.country.linkFormPath).updateValueAndValidity();
  }

  /**
   * setValidatorOwner
   * @param formData formData
   * @param formConfig formConfig
   * @param patternEmail patternEmail
   * @param patternMobile patternMobile
   * @param patternCP patternCP
   * @param chooseOne chooseOne
   */
  public setValidatorOwner(formData: any, formConfig: any, patternEmail: any, patternMobile: any, patternCP: any, chooseOne: any): void {
    this.formDataUtils = formData;
    this.formConfigUtils = formConfig;
    if (chooseOne === 'Particular') {
      // Se limpia validación - empresa
      this.formDataUtils.get(this.formConfigUtils.bussines.companySector.linkFormPath).clearValidators();
      this.formDataUtils.get(this.formConfigUtils.bussines.direction.linkFormPath).clearValidators();
      this.formDataUtils.get(this.formConfigUtils.bussines.companySector.linkFormPath).updateValueAndValidity();
      this.formDataUtils.get(this.formConfigUtils.bussines.direction.linkFormPath).updateValueAndValidity();
      // Set validación particular
      this.formDataUtils.get(this.formConfigUtils.particular.name.linkFormPath).setValidators([Validators.required]);
      this.formDataUtils.get(this.formConfigUtils.firstSurname.linkFormPath).setValidators([Validators.required]);
      this.formDataUtils.get(this.formConfigUtils.particular.name.linkFormPath).updateValueAndValidity();
      this.formDataUtils.get(this.formConfigUtils.firstSurname.linkFormPath).updateValueAndValidity();
      const elemList: any = this.formConfigUtils.documentType.options.list;
      elemList.map(
        (items: any, index: any) => {
          if (items.name === 'CIF') {
            this.formConfigUtils.documentType.options.list.splice(index, 1);
          }
        }
      );
    }
    if (chooseOne === 'Empresa') {
      // Se limpia validación - particular
      this.formDataUtils.get(this.formConfigUtils.particular.name.linkFormPath).clearValidators();
      this.formDataUtils.get(this.formConfigUtils.firstSurname.linkFormPath).clearValidators();
      this.formDataUtils.get(this.formConfigUtils.particular.name.linkFormPath).updateValueAndValidity();
      this.formDataUtils.get(this.formConfigUtils.firstSurname.linkFormPath).updateValueAndValidity();
      // Set validación empresa
      this.formDataUtils.get(this.formConfigUtils.bussines.companySector.linkFormPath).setValidators([
        Validators.required]);
      this.formDataUtils.get(this.formConfigUtils.bussines.direction.linkFormPath).setValidators([
        Validators.required]);
      this.formDataUtils.get(this.formConfigUtils.bussines.companySector.linkFormPath).updateValueAndValidity();
      this.formDataUtils.get(this.formConfigUtils.bussines.direction.linkFormPath).updateValueAndValidity();
      this.formConfigUtils.documentType.options.list.push({ name: 'CIF', id: Numbers.number2 });
    }
    this.formDataUtils.get(this.formConfigUtils.typeOwner.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.documentType.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.documentNumber.linkFormPath).setValidators([
      maxLenghtValidator(Numbers.number15), Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.email.linkFormPath).setValidators([
      Validators.pattern(patternEmail), Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.telephone.linkFormPath).setValidators([
      Validators.pattern(patternMobile), Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.direction.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.postalCode.linkFormPath).setValidators([
      Validators.pattern(patternCP), Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.municipality.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.province.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.country.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(this.formConfigUtils.typeOwner.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.email.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.telephone.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.postalCode.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.municipality.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.province.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(this.formConfigUtils.country.linkFormPath).updateValueAndValidity();
  }

  /**
   * removeValidatorOwner
   * @param formData formData
   * @param formConfig formConfig
   */
  public removeValidatorOwner(formData: any, formConfig: any): void {
    this.formDataUtils = formData;
    // Se limpia validación - empresa
    this.formDataUtils.get(formConfig.bussines.companySector.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.bussines.direction.linkFormPath).clearValidators();
    // Se limpia validación - particular
    this.formDataUtils.get(formConfig.particular.name.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.typeOwner.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.documentType.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.email.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.telephone.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.direction.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.municipality.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.province.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.country.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.bussines.companySector.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.bussines.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.particular.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.typeOwner.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.email.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.telephone.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.municipality.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.province.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.country.linkFormPath).updateValueAndValidity();
  }

  /**
   * showModalDialog2
   */
  showModalDialog2(): void {
    this.displayModal2 = true;
    this.showModal2 = this.displayModal2;
  }

  /**
   * setDefaultValueTypeOwner
   * @param formData formData
   * @param formConfig formConfig
   */
  setDefaultValueTypeOwner(formData: any, formConfig: any): void {
    this.formDataUtils = formData;
    if (formData && formConfig) {
      this.typeOwner = formData.get(formConfig.typeOwner.linkFormPath).value;
      if (!this.typeOwner) {
        this.formDataUtils
          .get(formConfig.typeOwner.linkFormPath)
          .setValue(formConfig.typeOwner.value);
      }
    }
  }

  /**
   * enableData
   * @param formData formData
   * @param formConfig formConfig
   * @param insureSelected insureSelected
   */
  enableData(formData: any, formConfig: any, insureSelected: any): void {
    this.formDataUtils = formData;
    this.formDataUtils.get(formConfig.bussines.direction.linkFormPath).setValue('');
    this.formDataUtils.get(formConfig.direction.linkFormPath).setValue('');
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).setValue('');
    this.formDataUtils.get(formConfig.telephone.linkFormPath).setValue('');
    this.formDataUtils.get(formConfig.email.linkFormPath).setValue('');
    this.formDataUtils.get([insureSelected, 'insuredData', 'provinceId']).setValue('');
    this.disabledRazSo = false;
    this.disabledEmail = false;
    this.disabledPhone = false;
    this.disabledDir = false;
    this.disabledCP = false;
    this.disabledMuni = false;
    this.disabledProv = false;
    this.disabledSec = false;
    const auxSectorChange: any = { name: '', id: 0 };
    const municipalityChange: any = { name: '', id: 0 };
    this.sectorchange = { name: 'sector', value: auxSectorChange };
    this.utilsExtended2.munichange = { name: 'municipio', value: municipalityChange };
  }

  /**
   * setCIFDataUtils
   * @param data data
   * @param formDataValue formDataValue
   * @param formData formData
   * @param formConfig formConfig
   */
  setCIFDataUtils(data: any, formDataValue: any, formData: FormGroup, formConfig: any): void {
    this.formDataUtils = formData;
    if (data.idSector !== null) {
      const auxSector: any = formDataValue.sectorList;
      auxSector.forEach((item: any) => {
        if (item.id === data.idSector) {
          const auxSectorChange: any = { name: item.name, id: item.id };
          this.sectorchange = { name: 'sector', value: auxSectorChange };
        }
      });
    }

    this.formDataUtils.get(formConfig.bussines.direction.linkFormPath).setValue(data.nombreRazonSocial);
    this.formDataUtils.get(formConfig.direction.linkFormPath).setValue(data.direccion);
    this.formDataUtils.get(formConfig.postalCode.linkFormPath).setValue(data.codPostal);
    this.formDataUtils.get(formConfig.email.linkFormPath).setValue(data.email);
    this.disabledRazSo = false;
    if (data.nombreRazonSocial !== '') { this.disabledRazSo = true; }
    this.disabledEmail = false;
    if (data.email !== '') { this.disabledEmail = true; }
    this.disabledDir = false;
    if (data.direccion !== '') { this.disabledDir = true; }
    this.disabledCP = false;
    if (data.codPostal !== '') { this.disabledCP = true; }
    this.disabledMuni = false;
    if (data.codPostal !== '') { this.disabledMuni = true; }
    this.disabledProv = false;
    if (data.codPostal !== '') { this.disabledProv = true; }
    this.disabledSec = false;
    if (data.idSector !== null) { this.disabledSec = true; }
  }

  /**
   * Transform the email to lowerCase
   * @param formData formData
   * @param formConfig formCongig
   */
    transformLower(formData: any, formConfig: any): void {
      this.formDataUtils = formData;
      const LOWER: string = this.formDataUtils.get(formConfig.email.linkFormPath).value.toString().toLowerCase();
      this.formDataUtils.get(formConfig.email.linkFormPath).setValue(LOWER);
    }

}
